module.exports = __webpack_public_path__ + "img/Suriname.e03b9b0d.png";